import { createSlice } from "@reduxjs/toolkit";
// utils
import axios from "../../utils/axios";
//
import { dispatch } from "../store";

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: null,
  tickets: { count: 0, data: [], num_pages: 1, page: 1, page_size: "5" },
};

const slice = createSlice({
  name: "ticket",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET TICKETS
    getTicketsSuccess(state, action) {
      state.isLoading = false;
      state.tickets = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions

// ----------------------------------------------------------------------

export function getTickets(
  page = 1,
  rowsPerPage = 5,
  filterName,
  filterStartDate,
  filterEndDate,
  filterUser,
  filterGame,
) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(
        `/api/v1/admin-api/tickets?page=${page}&page_size=${rowsPerPage}&ref_code=${filterName}&start_date=${filterStartDate}&end_date=${filterEndDate}&user=${filterUser}&game=${filterGame}`
      );
      dispatch(slice.actions.getTicketsSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export async function getTicket(keyId) {
  const response = await axios.get(`/api/v1/admin-api/ticket-id?keyId=${keyId}`);
  return response.data;
}
